// extracted by mini-css-extract-plugin
module.exports = {"sidebar__friends":"Sidebar_sidebar__friends__3rIZS"};